<template>
  <div
    class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
  >
    <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
      <button
        class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
        type="button"
        @click="addShow = true"
        :key="index"
      >
        <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
        <span class="p-l-20 p-r-10">Add Contact</span>
      </button>
    </div>
  </div>
  <dataTable
    :columnDefs="columnDefs"
    :name="'CustomerContacts'"
    ref="agGrid"
    :data="data"
    :addContextMenuItem="getContextMenuItems"
    @cellClicked="updateShow = $event.data"
  ></dataTable>
  <upsert v-if="addShow==true ||updateShow!=null" :customerId="setModel.Id" :setModel="updateShow"
    @update="$refs.agGrid.changeRow('Id', $event)"
    @add="$refs.agGrid.addRow([$event])"
    @close="updateShow = null; addShow=false;"></upsert>
</template>

<script>
import upsert from "./upsert.vue"
import moment from "moment";
export default {
  name: "Contacts",
  components:{upsert},
  props:{
    setModel: Object,
  },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
      columnDefs: [
        {
          headerName: "Id",
          width: 60,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "Name",
          width: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Email",
          filter: "agTextColumnFilter",
          field: "Email",
          width: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Phone",
          filter: "agTextColumnFilter",
          field: "Phone",
          width: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Note",
          filter: "agTextColumnFilter",
          field: "Note",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Position",
          filter: "agTextColumnFilter",
          field: "Position",
          width: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Deleted",
          width: 90,
          filter: "agNumberColumnFilter",
          field: "Deleted",
          // cellRenderer: this.$CheckCellRenderer,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          cellRenderer: function(e) {
            let clas = "success";
            if (e.value) {
              clas = "secondary";
            }
            return (
              '<span class="badge badge-' + clas + '">' + (e.value?'Deleted':'Active') + "</span>"
            );
          },
        },
        {
          headerName: "DeleteDate",
          filter: "agTextColumnFilter",
          field: "DeleteDate",
          width: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            return params.value==null?'':moment(new Date(params.value)).format("DD-MM-YYYY HH:mm");
          },
        },
      ],
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`CustomerContacts/` + this.setModel.Id)
      .then((response) => {
        this.data = response.data;
      });
  },
  methods:{

    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Add",
          icon: "<i class='fas fa-plus'></i>",
          action: () => {
            this.addShow = true;
          },
        },
        {
          name: "Update",
          icon: "<i class='fas fa-pencil-alt'></i>",
          action: () => {
            this.updateShow = params.node.data;
          },
        },
      ];
      if(!params.node.data.Deleted){
        result.push(
        {
          name: "Remove",
          icon: "<i class='fas fa-trash-alt'></i>",
          action: () => {
            this.remove(params.node.data);
          },
        },)
      }
      return result;
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the customer contact named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`CustomerContacts/` + item.Id)
            .then((res) => {
              this.$refs.agGrid.changeRow('Id', res.data);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer contact has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  }
};
</script>

<style></style>
